import { render, staticRenderFns } from "./UIDatePickerMenu.vue?vue&type=template&id=85f37fb0&scoped=true"
import script from "./UIDatePickerMenu.vue?vue&type=script&lang=js"
export * from "./UIDatePickerMenu.vue?vue&type=script&lang=js"
import style0 from "./UIDatePickerMenu.vue?vue&type=style&index=0&id=85f37fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f37fb0",
  null
  
)

export default component.exports